import {
  Box,
  Center,
  Flex,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { Pagination, Table, TagCapsules } from "../../../../components";
import { InfoCircle } from "iconsax-react";
import { formatCurrency } from "../../../../utils/currency";
import { IColor } from "../../../../utils/selectColors";
import {
  IQueryFinancial,
  IResponseFinancial,
} from "../../../../hooks/useFinancial";
import {
  EMovementType,
  EVindiPaymentStatus,
} from "../../../../hooks/useFinancial/enum/Enum";
import { convertToDateAndHour } from "../../../../utils/date";
import { useTranslation } from "react-i18next";
import { tradutorCategory } from "../../../../utils/SubCategorys";
import { client_selected } from "../../../../client";

interface IProps {
  data: IResponseFinancial;
  query: IQueryFinancial;
  setQuery: React.Dispatch<React.SetStateAction<IQueryFinancial>>;
}

const TableEdit = ({ data, query, setQuery }: IProps) => {
  // console.log("🚀 ~ data:", data);

  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isGenial = client_selected.name === "Genial";

  const pagination = {
    page: query.page,
    pageSize: query.pageSize,
    totalElements: data?.totalElements,
    totalPages: data?.totalPages,
    view: data?.data?.length || 0,
  };

  const paymentStatusLabels: Record<EVindiPaymentStatus, string> = {
    [EVindiPaymentStatus.REJECTED]: t("global.vindi_payment_status.REJECTED"),
    [EVindiPaymentStatus.SUCCESS]: t("global.vindi_payment_status.SUCCESS"),
    [EVindiPaymentStatus.PROCESSING]: t(
      "global.vindi_payment_status.PROCESSING"
    ),
    [EVindiPaymentStatus.FAILURE]: t("global.vindi_payment_status.FAILURE"),
    [EVindiPaymentStatus.TIMEOUT]: t("global.vindi_payment_status.TIMEOUT"),
    [EVindiPaymentStatus.WAITING]: t("global.vindi_payment_status.WAITING"),
    [EVindiPaymentStatus.CANCELED]: t("global.vindi_payment_status.CANCELED"),
    [EVindiPaymentStatus.FRAUD_REVIEW]: t(
      "global.vindi_payment_status.FRAUD_REVIEW"
    ),
  };

  const rows = data.data.map((element, index) => (
    <tr key={index}>
      <td
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {element?.debit_transaction_at &&
          convertToDateAndHour(element.debit_transaction_at)}
      </td>
      {/* <td
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        <Flex align="center">
          <TagCapsules
            mr={12}
            border
            colorTag={
              element?.movement_type === EMovementType.COMPRA
                ? IColor.orange
                : element?.movement_type === EMovementType.SAQUE
                ? IColor.purple
                : IColor.babyBlue
            }
          >
            {isGenial ? "Debito" : element?.movement_type_text}
          </TagCapsules>
        </Flex>
      </td> */}
      <td
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {!!element?.product ? (
          <Box>
            <Text
              tt="uppercase"
              fz={{ base: 12 }}
              fw={{ base: 500 }}
              lh={{ base: "155%" }}
              c={"basic.4"}
            >
              {t(tradutorCategory(element?.product.category).title)}
            </Text>
            <Text
              fz={{ base: 14 }}
              fw={{ base: 500 }}
              lh={{ base: "32px" }}
              c={"basic.5"}
            >
              {element?.product.title}
            </Text>
          </Box>
        ) : (
          "---"
        )}
      </td>
      <td
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {element?.payment_type}
      </td>
      <td
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {element?.debit_amount === null
          ? "---"
          : formatCurrency(element?.debit_amount, true)}
      </td>

      {/* <td
        style={{
          height: "100%",
          padding: 0,
        }}
      >
        <Tooltip
          label={
            !!element?.vindi_payment_status_text
              ? element?.vindi_payment_status_text
              : ""
          }
          color="dark"
          position="right"
          withArrow
        >
          <InfoCircle size="24" color={theme.colors.other[5]} variant="Bold" />
        </Tooltip>
      </td> */}
    </tr>
  ));

  const colsTable = (
    <tr style={{ width: "100%", gap: "12px" }}>
      <th
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {t("meu_perfil.financeiro.table.date")}
      </th>
      {/* <th
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {t("meu_perfil.financeiro.table.movement")}
      </th> */}
      <th
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {t("meu_perfil.financeiro.table.product")}
      </th>
      <th
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {t("meu_perfil.financeiro.table.payment")}
      </th>
      <th
        style={{
          textAlign: "start",
          verticalAlign: "middle",
        }}
      >
        {t("meu_perfil.financeiro.table.value")}
      </th>
      {/* <th>
        <Center>
          <Tooltip
            label={t("meu_perfil.financeiro.table.details")}
            color="dark"
            withArrow
          >
            <InfoCircle
              size="24"
              color={theme.colors.basic[5]}
              variant="Bold"
            />
          </Tooltip>
        </Center>
      </th> */}
    </tr>
  );

  return (
    <Flex w="100%" direction="column">
      {/* <PurchaseDatails opened={opened} close={close} selected={idcol} /> */}

      <Table cols={colsTable} rows={rows} sx={{ borderRadius: "15px" }} />

      <Flex
        bg={theme.colors.basic[0]}
        justify="space-between"
        align="center"
        mb={32}
        py={{ base: 24 }}
        px={{ base: 32 }}
        sx={{
          borderRadius: "0 0 12px 12px",
          border: "1.5px solid",
          borderTop: "none",
          borderColor: theme.colors.basic[2],
        }}
      >
        <Pagination
          pagination={pagination}
          onChange={(page) => setQuery({ ...query, page: page })}
        />
      </Flex>
    </Flex>
  );
};

export default TableEdit;
